module.exports = __webpack_public_path__ + "static/media/path.3a2ecaec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/path.png
// module id = 40
// module chunks = 0